module.exports = __webpack_public_path__ + "static/img/corelist.02530295.png";